module.exports = __webpack_public_path__ + "img/anto_milo.57b6df5b.jpeg";